module.exports = __webpack_public_path__ + "static/media/ela.26cf83a1.png";